<template>
	<FontAwesomeIcon v-bind="$attrs" :icon="icon" />
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
	name: 'Icon',
	components: {
		FontAwesomeIcon
	},
	inheritAttrs: false,
	props: {
		icon: {
			type: [String, Array, Object],
			required: true
		}
	}
}
</script>
